// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2a685c18","453":"5374acb4","455":"3b0092ac"}[chunkId] + ".chunk.js";
};